import { render, staticRenderFns } from "./manufacturing-series.vue?vue&type=template&id=eaa17bae"
import script from "./manufacturing-series.vue?vue&type=script&lang=ts"
export * from "./manufacturing-series.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports